import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title: string
  description: string
  image?: string
  className?: string
  onClick?: () => void
}

export const BannerPromo = ({
  title,
  description,
  image,
  className,
  onClick,
}: Props) => {
  return (
    <div
      id="promo-banner"
      className={clsx(s.card, className)}
      onClick={onClick}
    >
      <div className={s.content}>
        <div className={clsx(s.title, 'extra-bold-18')}>{title}</div>
        <p className={clsx(s.description, 'medium-12')}>{description}</p>
      </div>

      {image && (
        <div className={s.imageWrapper}>
          <img
            src={image}
            className={s.image}
            alt="promo-banner"
          />
        </div>
      )}
    </div>
  )
}
